import { useRef } from 'react';
import FormInput from 'components/form-input';
import PlateNumberPredict from 'components/plate-number-predict';
import RadioButton from 'components/radio-button';
import { LICENSE_PLATE_TYPES } from 'model/license-plate';
import { ENERGY_SOURCE_TYPES } from 'model/energy-source';
import styles from './index.module.sass';

const PlateNumberForm = ({
  title,
  plateNumber,
  plateNumberErrorMessage,
  onPlateNumberFocus,
  onPlateNumberChange,
  carType,
  onCarTypeChanged,
  energySource,
  onEnergySourceChange,
}) => {
  const plateNumberRef = useRef();

  return (
    <>
      <div className={styles.title}>{title}</div>
      <div className={styles.desc}>
        前往支援麻吉付地點時，將自動辨識您的車牌，將車牌作為您的付款通行證，付款更快速。
      </div>
      <div className={styles.form}>
        <FormInput
          ref={plateNumberRef}
          onFocus={onPlateNumberFocus}
          placeholder="輸入扣款車號，含 - 橫線"
          value={plateNumber}
          allCap={true}
          maxLength={8}
          onTextChanged={value => {
            plateNumberRef.current.focus();
            onPlateNumberChange(value);
          }}
          errorMessage={plateNumberErrorMessage}
        />
        <PlateNumberPredict value={plateNumber} onPlateNumberChange={onPlateNumberChange} />
        <div className={styles['section']}>
          <span>車種</span>
          <RadioButton theme="blue" defaultValue={carType} data={LICENSE_PLATE_TYPES} onClick={onCarTypeChanged} />
        </div>
        <div className={styles['section']}>
          <span>動力類型</span>
          <RadioButton theme="blue" defaultValue={energySource} data={ENERGY_SOURCE_TYPES} onClick={onEnergySourceChange} />
        </div>
      </div>
    </>
  );
};

export default PlateNumberForm;
